import { render } from "./BlogContent.vue?vue&type=template&id=0b49be28&scoped=true&ts=true"
import script from "./BlogContent.vue?vue&type=script&lang=ts"
export * from "./BlogContent.vue?vue&type=script&lang=ts"

import "./BlogContent.vue?vue&type=style&index=0&id=0b49be28&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b49be28"]])

export default __exports__